var _defs, _rect, _text, _text2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExplanation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 320,
    viewBox: "0 0 560 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0A0B0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0B0D12"
  })), /*#__PURE__*/React.createElement("style", null, "\n      :root{ --ink:#EAF2FF; --muted:#9AA4B2; --stroke:#1E2330; }\n      text{font-family:Inter,system-ui}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 320,
    fill: "url(#bg3)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 40,
    fill: "var(--ink)",
    fontSize: 18,
    fontWeight: 700
  }, "AI Explanation")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 58,
    fill: "var(--muted)",
    fontSize: 12
  }, "clear, traceable reasoning")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24,88)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 14,
    ry: 14,
    fill: "#11151C",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 26,
    r: 6,
    fill: "#46C8FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 26,
    r: 6,
    fill: "#8EDCFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 42,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#232833"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: -8,
    width: 420,
    height: 160,
    rx: 12,
    ry: 12,
    fill: "#141820",
    stroke: "var(--stroke)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80,24 88,32 88,16",
    fill: "#141820"
  }), /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 18,
    fill: "var(--ink)",
    fontWeight: 700,
    fontSize: 13
  }, "AI Insight"), /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 42,
    fill: "var(--muted)",
    fontSize: 12,
    fontWeight: 600
  }, "\n      \uD83D\uDCCA Patterns: Descending Triangle: 3 cases, Downward Price Channel: 1 cases, Potential Breakdown: 1 cases\n    "), /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 64,
    fill: "#C9D4E3",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 0
  }, "The last three candles show a bullish continuation pattern with a small doji"), /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 16
  }, "followed by a green candle, indicating buying pressure. Support is identified at"), /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 16
  }, "$683.25 and resistance at $683.54. No bearish reversal patterns (engulfing,"), /*#__PURE__*/React.createElement("tspan", {
    x: 108,
    dy: 16
  }, "shooting star) are present.")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108,132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    rx: 8,
    ry: 8,
    width: 66,
    height: 20,
    fill: "#0F1218",
    stroke: "#202633"
  }), /*#__PURE__*/React.createElement("text", {
    x: 33,
    y: 14,
    textAnchor: "middle",
    fill: "#8FA3BF",
    fontSize: 11
  }, "c_20"), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 0,
    rx: 8,
    ry: 8,
    width: 84,
    height: 20,
    fill: "#0F1218",
    stroke: "#202633"
  }), /*#__PURE__*/React.createElement("text", {
    x: 116,
    y: 14,
    textAnchor: "middle",
    fill: "#8FA3BF",
    fontSize: 11
  }, "RR &gt; 1.3"), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 0,
    rx: 8,
    ry: 8,
    width: 96,
    height: 20,
    fill: "#0F1218",
    stroke: "#202633"
  }), /*#__PURE__*/React.createElement("text", {
    x: 212,
    y: 14,
    textAnchor: "middle",
    fill: "#8FA3BF",
    fontSize: 11
  }, "ATR-aware")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplanation);
export default __webpack_public_path__ + "static/media/explanation.08f6d38256ef4fd9d9ffc697b46a29fe.svg";
export { ForwardRef as ReactComponent };